import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  searchResult: undefined,
  history: undefined,
  modal: {
    visible: false,
    release: null,
    auto: false,
  },
}

export default {
  state,
  actions,
  getters,
  mutations,
}
